/**
 * GeoJsonLayer类
 */
import L from 'leaflet';
// 引入 leaflet.markercluster
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "leaflet.markercluster";
import context from '../context';
import ContextMenu from '../components/ContextMenu';
var myIcon = L.icon({
    iconUrl: '/source/images/coffee.png',
    iconSize: [38, 95],
    iconAnchor: [22, 94],
    popupAnchor: [-3, -76],
    shadowUrl: 'my-icon-shadow.png',
    shadowSize: [68, 95],
    shadowAnchor: [22, 94]
});
function onAction(val){
    console.log(val);
}
var cmIcon = <ContextMenu onAction={onAction}>{myIcon}</ContextMenu>
export default L.Layer.extend({
    options: {
        layerId: null,
        geoJson: null
    },
    // 定义初始化方法
    initialize: function (options) {
        console.log(context.map);
        L.setOptions(this, options);
    },

    // 在 addLayer 方法中定义如何向地图添加图层
    onAdd: function (map) {
        console.log(map);
        this._map = map;
        // 在这里可以添加图层到地图上
        // 比如，创建 DOM 元素并将其添加到地图容器中 想起的淮阳庙会的泥泥狗
        this._mapLayer = L.geoJSON(this.options.data,
            {
                pointToLayer: function (geoJsonPoint, latlng) {
                    return L.marker(latlng,{
                        icon:cmIcon
                    });
                },
                style: function (feature) {
                    return {color: feature.properties.color};
                },
                filter: function (feature) {
                    return true;
                },
                // coordsToLatLng: function (feature) {
                //     return true;
                // },
            }
        ).bindPopup(function (layer) {
            return layer.feature.properties.description;
        });
        this._map.addLayer(this._mapLayer)
    },

    // 在 removeLayer 方法中定义如何从地图移除图层
    onRemove: function (map) {
        console.log(map);
        // 在这里可以移除图层，清理资源等操作
    }
});